import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

export const FAQ = ({ faq = {} }) => {
  const items = faq.items || [];
  return (
    <section id="faq" className="scroll-anchor bg-secondary/40">
      <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <Reveal>
          <div className="text-center">
            <p className="text-sm font-semibold uppercase tracking-wider text-accent">{faq.eyebrow}</p>
            <h2 className="font-display mt-2 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">{faq.heading}</h2>
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <Accordion type="single" collapsible className="mt-8" data-testid="faq-accordion">
            {items.map((f, i) => (
              <AccordionItem key={f.q || i} value={`item-${i}`} className="border-b border-border">
                <AccordionTrigger className="text-left text-base font-medium text-foreground hover:no-underline" data-testid={`faq-trigger-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
